export const WorkData = [
   {
      company: "IGC Business Holding (Full time)",
      designation: "Front-End (React JS) Developer",
      dateJoining: "13-01-2025",
      dateEnd: "Present",
      companyLogo: require("../../assets/work/nepdroid.png"),
      work: "Working as a Lead Front-End Web Developer(React JS, NEXT.JS)",
   },
   {
      company: "Mero Vision (Part time)",
      designation: "Front-End (React JS) Developer",
      dateJoining: "10-05-2024",
      dateEnd: "Present",
      companyLogo: require("../../assets/work/nepdroid.png"),
      work: "Working as a Lead Front-End Web Developer(React JS, NEXT.JS)",
   },
   {
      company: "Scodus Innovations (Full time)",
      designation: "React JS Developer",
      dateJoining: "21-09-2022",
      dateEnd: "27-12-2024",
      companyLogo: require("../../assets/work/nepdroid.png"),
      work: "Worked as a Front-End Web Developer(React JS, NEXT.JS)",
   },
];
